export default __webpack_public_path__ + "static/media/KZ.T.13.2501.62c170a2.svg";